$(document).ready(function() {
    if (window.innerWidth < 1024) {
        initScrollerSlider('.scroller', 1024);
    } else {
        $('.scroller').removeClass('init')
    }
    if (window.innerWidth <= 768) {
        initSlider('.companies-scroller', 768);
    } else {
        $('.companies-scroller').removeClass('init')
    }

    $(window).resize(function() {
        if (window.innerWidth <= 1024 && !$('.scroller').hasClass('init')) {
            $('.scroller').addClass('init')
            initScrollerSlider('.scroller', 1024);
        }
        if (window.innerWidth > 1024 && $('.scroller').hasClass('init')) {
            $('.scroller').removeClass('init')
        }

        if (window.innerWidth <= 768 && !$('.companies-scroller').hasClass('init')) {
            $('.companies-scroller').addClass('init')
            initSlider('.companies-scroller', 768);
        }

        if (window.innerWidth > 768 && $('.companies-scroller').hasClass('init')) {
            $('.companies-scroller').removeClass('init')
        }
    });
});


function initSlider(className, breakpoint) {
    $(className).slick({
        dots: false,
        infinite: false,
        speed: 300,
        mobileFirst:true,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: breakpoint,
                settings: "unslick"
            }
        ],
    });
} 
function initScrollerSlider(className, breakpoint) {
    $(className).slick({
        dots: false,
        infinite: false,
        speed: 300,
        mobileFirst:true,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: breakpoint,
                settings: "unslick"
            }
        ],
    });
} 